"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _deck = _interopRequireDefault(require("deck.gl"));

var _reactMapGl = _interopRequireWildcard(require("react-map-gl"));

var _centroid = _interopRequireDefault(require("@turf/centroid"));

var _bbox = _interopRequireDefault(require("@turf/bbox"));

var _utils = require("./utils");

var _Constants = require("./Constants");

var _DeckSidebarContainer = _interopRequireDefault(require("./components/decksidebar/DeckSidebarContainer"));

require("./App.css");

var _Tooltip = _interopRequireDefault(require("./components/Tooltip"));

var _geojsonutils = require("./geojsonutils");

var _lodash = require("lodash");

var _JSUtils = require("./JSUtils");

var _Widgets = require("./components/showcases/Widgets");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
var gradient = {
  height: '200px',
  backgroundColor: 'red',
  backgroundImage: 'linear-gradient(to top, red , yellow)'
};

var Welcome = function (_React$Component) {
  _inherits(Welcome, _React$Component);

  var _super = _createSuper(Welcome);

  function Welcome(props) {
    var _this;

    _classCallCheck(this, Welcome);

    _this = _super.call(this, props);
    var init = props.viewport && Object.keys(props.viewport) ? Object.assign(_Constants.DECKGL_INIT, props.viewport) : _Constants.DECKGL_INIT;
    var param = (0, _utils.getParamsFromSearch)(props.location ? props.location.search : window.location.search);

    if (param) {
      Object.keys(param).forEach(function (key) {
        Object.keys(init).forEach(function (iKey) {
          if (iKey.startsWith(key)) {
            init[key] = param[key];
          }
        });
      });
    }

    _this.state = {
      loading: true,
      layers: [],
      backgroundImage: gradient.backgroundImage,
      mapStyle: MAPBOX_ACCESS_TOKEN ? "mapbox://styles/mapbox/" + (props.dark ? "dark" : "streets") + "-v9" : (0, _utils.getOSMTiles)(),
      initialViewState: init,
      subsetBoundsChange: false,
      lastViewPortChange: new Date(),
      colorName: 'default',
      iconLimit: _Constants.ICONLIMIT,
      legend: false,
      multiVarSelect: {},
      width: window.innerWidth,
      height: window.innerHeight,
      tooltipColumns: {
        column1: "accident_severity",
        column2: "date"
      },
      geographyURL: props.geographyURL,
      geographyColumn: props.geographyColumn,
      column: props.column,
      layerStyle: props.layerStyle,
      bottomPanel: false
    };
    _this._generateLayer = _this._generateLayer.bind(_assertThisInitialized(_this));
    _this._renderTooltip = _this._renderTooltip.bind(_assertThisInitialized(_this));
    _this._fetchAndUpdateState = _this._fetchAndUpdateState.bind(_assertThisInitialized(_this));
    _this._fitViewport = _this._fitViewport.bind(_assertThisInitialized(_this));
    _this._initWithGeojson = _this._initWithGeojson.bind(_assertThisInitialized(_this));
    _this._initDataState = _this._initDataState.bind(_assertThisInitialized(_this));
    _this._updateStateAndLayers = _this._updateStateAndLayers.bind(_assertThisInitialized(_this));
    _this._resize = _this._resize.bind(_assertThisInitialized(_this));
    _this._updateURL = _this._updateURL.bind(_assertThisInitialized(_this));
    _this._throttleUR = (0, _lodash.throttle)(function (v) {
      return _this._updateURL(v);
    }, 300);
    return _this;
  }

  _createClass(Welcome, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(nextProps) {
      var data = nextProps.data,
          defaultURL = nextProps.defaultURL,
          geographyURL = nextProps.geographyURL,
          geographyColumn = nextProps.geographyColumn;

      if (JSON.stringify(data) !== JSON.stringify(this.props.data) || defaultURL !== this.props.defaultURL || geographyURL !== this.props.geographyURL || geographyColumn !== geographyColumn) {
        this._initDataState();

        return true;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._initDataState();

      window.addEventListener('resize', this._resize);
    }
  }, {
    key: "_initDataState",
    value: function _initDataState() {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          defaultURL = _this$props.defaultURL;

      if ((0, _JSUtils.isObject)(data) && data.features && data.features.length) {
        this.setState({
          loading: false,
          data: data
        }, function () {
          _this2._fitViewport();

          _this2._generateLayer();
        });
      } else {
        if (defaultURL) {
          this._fetchAndUpdateState(defaultURL);
        } else {
          this.setState({
            loading: false
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._resize);
    }
  }, {
    key: "_fetchAndUpdateState",
    value: function _fetchAndUpdateState(aURL, customError) {
      var _this3 = this;

      if (aURL && !(0, _utils.isURL)(aURL)) {
        if (this.state.loading) {
          this.setState({
            loading: false
          });
        }

        return;
      }

      ;
      if (customError && _typeof(customError) !== 'object') return;
      (0, _utils.fetchData)(aURL, function (data, error) {
        var geographyURL = _this3.props.geographyURL;

        if ((0, _utils.isURL)(geographyURL)) {
          (0, _utils.fetchData)(geographyURL, function (geojson, geoErr) {
            _this3._updateStateAndLayers(geoErr, geojson, data, customError, geographyURL);
          });
        } else {
          _this3._initWithGeojson(error, data, customError, aURL);
        }
      });
    }
  }, {
    key: "_updateStateAndLayers",
    value: function _updateStateAndLayers(geoErr, geojson, data, customError, geographyURL) {
      var _this4 = this;

      if (!geoErr) {
        this.setState({
          loading: false,
          geography: geojson,
          data: data,
          alert: customError || null
        }, function () {
          _this4._fitViewport(geojson);

          _this4._generateLayer();
        });
      } else {
        this.setState({
          loading: false,
          alert: {
            content: 'Could not reach: ' + geographyURL
          }
        });
      }
    }
  }, {
    key: "_initWithGeojson",
    value: function _initWithGeojson(error, data, customError, fullURL) {
      if (!error) {
        this.setState({
          loading: false,
          data: data,
          alert: customError || null
        });

        this._fitViewport(data);

        this._generateLayer();
      } else {
        this.setState({
          loading: false,
          alert: {
            content: 'Could not reach: ' + fullURL
          }
        });
      }
    }
  }, {
    key: "_generateLayer",
    value: function _generateLayer() {
      var _this5 = this;

      var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _values$layerOptions = values.layerOptions,
          layerOptions = _values$layerOptions === void 0 ? {} : _values$layerOptions,
          filter = values.filter,
          cn = values.cn;

      if (filter && filter.what === 'mapstyle') {
        var newStyle = "mapbox://styles/mapbox/" + filter.selected + "-v9";
        this.setState({
          mapStyle: filter.what === 'mapstyle' ? filter.selected === "No map" ? _Constants.BLANKSTYLE : !MAPBOX_ACCESS_TOKEN ? (0, _utils.getOSMTiles)(filter.selected) : newStyle : this.state.mapStyle
        });
        return;
      }

      var _this$state = this.state,
          colorName = _this$state.colorName,
          iconLimit = _this$state.iconLimit,
          geography = _this$state.geography,
          geographyColumn = _this$state.geographyColumn,
          multiVarSelect = _this$state.multiVarSelect;
      var data = this.props.data && this.props.data.features || this.state.data && this.state.data.features;
      if (!data) return;
      var column = filter && filter.what === 'column' && filter.selected || this.state.column;
      var columnNameOrIndex = column || 0;

      if (filter && filter.what === "%") {
        data = data.slice(0, filter.selected / 100 * data.length);
      }

      if (this.state.coords || filter && filter.what === 'column') {
        data = this.state.filtered;
      }

      var filterValues = filter && filter.what === 'multi' || Object.keys(multiVarSelect).length;
      var filterCoords = filter && filter.what === 'coords';
      var selected = filter && filter.what === 'multi' && filter.selected || multiVarSelect;

      if (filterValues || filterCoords) {
        data = data.filter(function (d) {
          if (filterValues) {
            for (var _i = 0, _Object$keys = Object.keys(selected); _i < _Object$keys.length; _i++) {
              var each = _Object$keys[_i];
              var nextValue = d.properties[each] + "";

              if (!selected[each].has(nextValue)) {
                return false;
              }
            }
          }

          if (filterCoords) {
            if (_.difference(filter.selected || _this5.state.coords, d.geometry.coordinates.flat()).length !== 0) {
              return false;
            }
          }

          return true;
        });

        if (!data || !data.length) {
          this.setState({
            alert: {
              content: 'Filtering returns no results'
            }
          });
          return;
        }

        ;
      }

      var geomType = (0, _geojsonutils.sfType)(geography ? geography.features[0] : data[0]).toLowerCase();

      if (geography) {
        if (data.length > geography.features.length) {}

        data = (0, _utils.setGeojsonProps)(geography, data, geographyColumn);

        if (!data || !data.features) {
          this.setState({
            alert: {
              content: 'Is there a matching geography column?'
            }
          });
          return;
        }

        ;
        data = data.features || data;
      }

      var layerStyle = filter && filter.what === 'layerStyle' && filter.selected || this.state.layerStyle || (0, _utils.suggestDeckLayer)(geography ? geography.features : data);
      if (!new RegExp("point", "i").test(geomType)) layerStyle = "geojson";
      var switchToIcon = data.length < iconLimit && !layerStyle && (!filter || filter.what !== 'layerStyle') && geomType === "point";
      if (switchToIcon) layerStyle = 'icon';
      var options = Object.assign(_objectSpread(_objectSpread({}, this.state.layerOptions), {}, {
        lightSettings: _Constants.LIGHT_SETTINGS,
        colorRange: (0, _utils.colorRanges)(cn || colorName),
        getColor: (0, _utils.getColorArray)(cn || colorName)
      }), layerOptions);
      var domain = (0, _utils.generateDomain)(data, columnNameOrIndex === 0 ? Object.keys(data[0].properties)[columnNameOrIndex] : columnNameOrIndex);

      if (layerStyle === 'heatmap') {
        options.getPosition = function (d) {
          return d.geometry.coordinates;
        };

        options.updateTriggers = {
          getWeight: typeof options.getWeight === 'function' && data.map(function (d) {
            return options.getWeight(d);
          })
        };
      }

      if (geomType === 'linestring') {
        layerStyle = "line";
        options.getColor = [235, 170, 20];

        options.getPath = function (d) {
          return d.geometry.coordinates;
        };

        options.onClick = function (info) {
          if (info && info.hasOwnProperty('coordinate')) {
            if (['path', 'arc', 'line'].includes(_this5.state.layerStyle) && info.object.geometry.coordinates) {
              _this5._generateLayer({
                filter: {
                  what: 'coords',
                  selected: info.object.geometry.coordinates[0]
                }
              });
            }
          }
        };

        if (layerStyle === 'line') {
          options.getSourcePosition = function (d) {
            return d.geometry.coordinates[0];
          };

          options.getTargetPosition = function (d) {
            return d.geometry.coordinates[1];
          };
        }

        if (+(data[0] && data[0].properties && data[0].properties[columnNameOrIndex])) {
          options.getWidth = function (d) {
            return _this5._newRange(data, d, columnNameOrIndex, (0, _utils.getMin)(domain), (0, _utils.getMax)(domain));
          };
        }
      }

      if (layerStyle === 'scatter') {
        if (+(data[0] && data[0].properties && data[0].properties[columnNameOrIndex])) {
          options.getRadius = function (d) {
            return _this5._newRange(data, d, columnNameOrIndex, (0, _utils.getMin)(domain), (0, _utils.getMax)(domain));
          };
        }
      }

      var newLegend = this.state.legend;

      var getValue = function getValue(d) {
        if (+columnNameOrIndex || +columnNameOrIndex === 0) {
          return d.properties[Object.keys(d.properties)[columnNameOrIndex]];
        } else {
          return d.properties[columnNameOrIndex];
        }
      };

      var fill = function fill(d) {
        return (0, _utils.colorScale)(+getValue(d) ? +getValue(d) : getValue(d), domain, 180, cn || _this5.state.colorName);
      };

      if (geomType === "polygon" || geomType === "multipolygon" || layerStyle === 'geojson') {
        options.getFillColor = fill;
        options.updateTriggers = {
          getFillColor: data.map(function (d) {
            return fill(d);
          })
        };
      }

      if (layerStyle === 'barvis') {
        options.getPosition = function (d) {
          return [d.geometry.coordinates[0], d.geometry.coordinates[1], 0];
        };

        options.getScale = 20;
        options.updateTriggers = {
          getRotationAngle: typeof options.getRotationAngle === 'function' && data.map(function (d) {
            return options.getRotationAngle(d);
          }),
          getWidth: typeof options.getWidth === 'function' && data.map(function (d) {
            return options.getWidth(d);
          })
        };
      }

      if (layerStyle === 'pointcloud') {
        options.getColor = fill;
        options.updateTriggers = {
          getColor: data.map(function (d) {
            return fill(d);
          }),
          getPosition: [data.length]
        };
      }

      var columnName = +columnNameOrIndex || +columnNameOrIndex === 0 ? Object.keys(data[0].properties)[columnNameOrIndex] : columnNameOrIndex;
      newLegend = (0, _utils.generateLegend)({
        domain: domain,
        title: (0, _utils.humanize)(columnName),
        interpolate: (0, _utils.colorRangeNamesToInterpolate)(cn || this.state.colorName)
      });
      var alayer = (0, _utils.generateDeckLayer)(layerStyle, data, this._renderTooltip, options);
      this.setState({
        alert: switchToIcon ? {
          content: 'Switched to icon mode. '
        } : null,
        loading: false,
        layerStyle: layerStyle,
        geomType: geomType,
        tooltip: "",
        filtered: data,
        layers: [alayer],
        layerOptions: options,
        multiVarSelect: filter && filter.what === "multi" ? filter.selected : multiVarSelect,
        road_type: filter && filter.what === 'road_type' ? filter.selected : this.state.road_type,
        colorName: cn || colorName,
        column: column,
        coords: filter && filter.what === 'coords' ? filter.selected : this.state.coords,
        legend: newLegend,
        bottomPanel: _react["default"].createElement(_Widgets.CustomSlider, {
          data: this.state.data.features,
          dates: (0, _geojsonutils.getPropertyValues)(this.state.data, "alt")
        })
      });
    }
  }, {
    key: "_fitViewport",
    value: function _fitViewport(newData, bboxLonLat) {
      var data = newData || this.state.data;
      if ((!data || data.length === 0) && !bboxLonLat) return;
      var bounds = bboxLonLat ? bboxLonLat.bbox : (0, _bbox["default"])(data);
      var center = bboxLonLat ? [bboxLonLat.lon, bboxLonLat.lat] : (0, _centroid["default"])(data).geometry.coordinates;
      this.map.fitBounds(bounds, {
        padding: '100px'
      });

      var viewport = _objectSpread(_objectSpread({}, this.state.viewport), {}, {
        longitude: center[0],
        latitude: center[1],
        transitionDuration: 500,
        transitionInterpolator: new _reactMapGl.FlyToInterpolator()
      });

      this.setState({
        viewport: viewport
      });
    }
  }, {
    key: "_renderTooltip",
    value: function _renderTooltip(params) {
      var x = params.x,
          y = params.y,
          object = params.object;
      var hoveredObject = object;

      if (!hoveredObject) {
        this.setState({
          tooltip: ""
        });
        return;
      }

      this.setState({
        tooltip: _react["default"].createElement(_Tooltip["default"], _extends({}, this.state.tooltipColumns, {
          isMobile: (0, _utils.isMobile)(),
          topx: x,
          topy: y,
          hoveredObject: hoveredObject
        }))
      });
    }
  }, {
    key: "_updateURL",
    value: function _updateURL(viewport) {
      var _this6 = this;

      var _this$state2 = this.state,
          subsetBoundsChange = _this$state2.subsetBoundsChange,
          lastViewPortChange = _this$state2.lastViewPortChange;

      if (new Date() - lastViewPortChange > 1000) {
        (0, _utils.updateHistory)(viewport);
        this.setState({
          lastViewPortChange: new Date()
        });
      }

      var bounds = this.map && this.map.getBounds();

      if (bounds && subsetBoundsChange) {
        var box = (0, _utils.getBbx)(bounds);
        var xmin = box.xmin,
            ymin = box.ymin,
            xmax = box.xmax,
            ymax = box.ymax;
        (0, _utils.fetchData)(this.props.defaultURL + xmin + "/" + ymin + "/" + xmax + "/" + ymax, function (data, error) {
          if (!error) {
            _this6.setState({
              data: data.features
            });

            _this6._generateLayer();
          } else {}
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var _this$props2 = this.props,
          hideCharts = _this$props2.hideCharts,
          hideChartGenerator = _this$props2.hideChartGenerator,
          dark = _this$props2.dark,
          defaultURL = _this$props2.defaultURL,
          leftSidebarContent = _this$props2.leftSidebarContent;
      var _this$state3 = this.state,
          tooltip = _this$state3.tooltip,
          viewport = _this$state3.viewport,
          initialViewState = _this$state3.initialViewState,
          loading = _this$state3.loading,
          mapStyle = _this$state3.mapStyle,
          alert = _this$state3.alert,
          data = _this$state3.data,
          filtered = _this$state3.filtered,
          bottomPanel = _this$state3.bottomPanel,
          layerStyle = _this$state3.layerStyle,
          geomType = _this$state3.geomType,
          legend = _this$state3.legend,
          coords = _this$state3.coords;
      var showLegend = legend && (geomType === 'polygon' || geomType === 'multipolygon' || layerStyle === "pointcloud");
      return _react["default"].createElement("div", null, _react["default"].createElement("div", {
        className: "loader",
        style: {
          zIndex: loading ? 999 : -1,
          visibility: typeof mapStyle === 'string' && mapStyle.endsWith("No map-v9") ? 'hidden' : 'visible'
        }
      }), _react["default"].createElement(_reactMapGl["default"], {
        preserveDrawingBuffer: true,
        ref: function ref(_ref2) {
          _this7.map = _ref2 && _ref2.getMap();
        },
        mapStyle: mapStyle,
        onViewportChange: function onViewportChange(viewport) {
          _this7._throttleUR(viewport);

          _this7.setState({
            viewport: viewport
          });
        },
        height: this.state.height + 'px',
        width: this.state.width + 'px',
        viewState: viewport ? viewport : initialViewState
      }, _react["default"].createElement("div", {
        className: "mapboxgl-ctrl-top-right",
        style: {
          zIndex: 9
        }
      }, _react["default"].createElement(_reactMapGl.NavigationControl, _extends({}, viewport, {
        onViewportChange: function onViewportChange(viewport) {
          return _this7.setState({
            viewport: viewport
          });
        }
      })), _react["default"].createElement(_reactMapGl.ScaleControl, {
        maxWidth: 100,
        unit: "metric",
        style: {
          left: 20,
          bottom: 100
        }
      })), _react["default"].createElement(_deck["default"], {
        ref: function ref(_ref) {
          return _this7.deck = _ref && _ref.deck;
        },
        viewState: viewport ? viewport : initialViewState,
        initialViewState: initialViewState,
        layers: this.state.layers,
        onClick: function onClick(e) {
          if (!e.layer && coords) {
            _this7.setState({
              coords: null
            });

            _this7._generateLayer();
          }
        }
      }, tooltip)), _react["default"].createElement(_DeckSidebarContainer["default"], {
        hideCharts: hideCharts,
        screenshot: function screenshot() {
          return (0, _utils.screenshot)(_this7.map, _this7.deck);
        },
        hideChartGenerator: hideChartGenerator,
        leftSidebarContent: leftSidebarContent,
        dark: dark,
        layerStyle: layerStyle,
        isMobile: (0, _utils.isMobile)(),
        key: "decksidebar",
        alert: alert,
        unfilteredData: data && data.features,
        data: filtered,
        colourCallback: function colourCallback(colorName) {
          return _this7._generateLayer({
            cn: colorName
          });
        },
        urlCallback: function urlCallback(url_returned, geojson_returned) {
          _this7.setState({
            geography: null,
            column: null,
            tooltip: "",
            loading: true,
            coords: null
          });

          if (geojson_returned) {
            try {
              _this7.setState({
                data: geojson_returned
              });

              _this7._fitViewport(geojson_returned);

              _this7._generateLayer();
            } catch (error) {
              _this7._fetchAndUpdateState(undefined, {
                content: error.message
              });
            }
          } else {
            if ((0, _utils.isURL)(url_returned)) {
              (0, _utils.fetchData)(url_returned, function (data, error) {
                if (!error) {
                  _this7._updateStateAndLayers(false, null, data);
                } else {
                  _this7.setState({
                    loading: false,
                    alert: {
                      content: 'Could not reach: ' + url_returned
                    }
                  });
                }
              });
            } else {
              _this7._initDataState();
            }
          }
        },
        column: this.state.column,
        onSelectCallback: function onSelectCallback(selected) {
          return _this7._generateLayer({
            filter: selected
          });
        },
        onLayerOptionsCallback: function onLayerOptionsCallback(layerOptions) {
          return _this7._generateLayer({
            layerOptions: layerOptions
          });
        },
        toggleSubsetBoundsChange: function toggleSubsetBoundsChange(value) {
          _this7.setState({
            loading: true,
            subsetBoundsChange: value
          });

          _this7._fetchAndUpdateState();
        },
        onlocationChange: function onlocationChange(bboxLonLat) {
          _this7._fitViewport(undefined, bboxLonLat);
        },
        datasetName: defaultURL,
        bottomPanel: bottomPanel
      }), showLegend && _react["default"].createElement("div", {
        style: _objectSpread({}, (0, _utils.theme)(this.props.dark)),
        className: "right-side-panel mapbox-legend"
      }, legend));
    }
  }, {
    key: "_resize",
    value: function _resize() {
      this.setState({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
  }, {
    key: "_newRange",
    value: function _newRange(data, d, columnNameOrIndex, min, max) {
      var newMax = 10,
          newMin = 0.1;

      if (data.length > 100000) {
        newMax = 0.5;
        newMin = 0.005;
      }

      var r = (0, _utils.convertRange)(d.properties[columnNameOrIndex], {
        oldMin: min,
        oldMax: max,
        newMax: newMax,
        newMin: newMin
      });
      return r;
    }
  }]);

  return Welcome;
}(_react["default"].Component);

exports["default"] = Welcome;